import type { AxiosInstance } from 'axios';
import { injectable } from 'inversify';
import { serializeError } from 'serialize-error';
import moment from 'moment';
import { TrackingContextProvider } from '../helper-services/TrackingContextProvider';

@injectable()
export class LogService {
  private axiosInstance: AxiosInstance;

  private trackingContextProvider: TrackingContextProvider;

  sessionId: string;

  constructor(axiosInstance: AxiosInstance, trackingContextProvider: TrackingContextProvider) {
    this.axiosInstance = axiosInstance;
    this.sessionId = '';
    this.trackingContextProvider = trackingContextProvider;
  }

  private getContext() {
    return {
      sessionId: this.sessionId,
      browserTrackId: this.trackingContextProvider.browserTrackId,
      instanceTrackId: this.trackingContextProvider.instanceTrackId,
      eventTime: moment().toJSON(),
    };
  }

  setSessionId(sessionId: string) {
    this.sessionId = sessionId;
  }

  async logError(error: any, context = {}, timeout = 5000) {
    await this.axiosInstance.post(
      'api/log/error/',
      {
        message: JSON.stringify(serializeError(error)),
        context: { ...this.getContext(), ...context },
      },
      { timeout }
    );
  }

  async logWarning(error: any, context = {}, timeout = 5000) {
    await this.axiosInstance.post(
      'api/log/warning/',
      {
        message: JSON.stringify(serializeError(error)),
        context: { ...this.getContext(), ...context },
      },
      { timeout }
    );
  }

  async logInfo(message: string, context = {}, timeout = 5000) {
    await this.axiosInstance.post('api/log/info/', { message, context: { ...this.getContext(), ...context } }, { timeout });
  }
}
